import * as React from "react";
import { Container } from "reactstrap";
import { QnaRelease } from "./qna-release";
import { getAsync } from "utils/net";
import { Environment } from "models/environment";
import { LuisRelease } from "./luis-release";
import { DialogsRelease } from "./dialogs-release";
import "./release-management.css";

type ReleaseManagerType = "qna" | "dialogs" | "luis";

export interface ReleaseManagementProps { }
export interface ReleaseManagementState {
    environments: Environment[],
    currentManagerType: ReleaseManagerType
}

export class ReleaseManagement extends React.Component<
    ReleaseManagementProps,
    ReleaseManagementState
    > {

    constructor(props: ReleaseManagementProps) {
        super(props);

        this.state = {
            environments: [],
            currentManagerType: "dialogs"
        }
    }

    async componentWillMount() {
        await this.getEnvironmentsAsync();
    }

    private async getEnvironmentsAsync() {
        try {
            const response = await getAsync("/api/ReleaseManagement/environments");
            if (!response.ok) {
                throw Error(response.statusText);
            }

            const environments: Environment[] = await response.json();

            if (environments) {
                this.setState({
                    environments: environments
                });
            } else {
                throw Error("Error retrieving environments");
            }

        } catch (error) {
            console.log(error);
        }
    }

    render() {
        return (
            <Container fluid={true} className="page">
                {this.state.environments && this.state.environments.length > 0 &&
                    (<div>
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a
                                    className="nav-link"
                                    onClick={() => this.setState({ currentManagerType: "dialogs" })}
                                >
                                    Dialogs
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" onClick={() => this.setState({ currentManagerType: "luis" })}>
                                    LUIS</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" onClick={() => this.setState({ currentManagerType: "qna" })}>
                                    QnA</a>
                            </li>
                        </ul>
                        {this.showReleaseManager()}
                    </div>)}
            </Container>);
    }

    private showReleaseManager() {
        switch (this.state.currentManagerType) {
            case "qna":
                return <QnaRelease environments={this.state.environments} />;
            case "dialogs":
                return <DialogsRelease environments={this.state.environments} />;
            case "luis":
                return <LuisRelease environments={this.state.environments} />;
            default:
                return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/release-management/release-management.tsx